export default function activeNewSofwareVersion() {
    return {
        type: activeNewSofwareVersion.type,
    };
}
activeNewSofwareVersion.type = 'ACTIVE_NEW_SOFTWARE_VERSION';
